import { BaseFlowStepEditor } from "./BaseFlowStepEditor";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import React from "react";
import { StepNameLabel } from "../Builder/Common/StepNameLabel";
import { StepDescription } from "../Builder/Common/StepDescription";
import { EditGrayIcon } from "../../CommonUI/Icon/EditGrayIcon";
import { DeleteGrayIcon } from "../../CommonUI/Icon/DeleteGrayIcon";
import { DescriptionIcon } from "../../CommonUI/Icon/DescriptionIcon";
import { FlowStepData } from "../../rule-engine-core/Flow/Steps/FlowStepData";
import styled from "styled-components";
import { AppGlueError } from "../../rule-engine-core/AppGlueError";
import { Box } from "@mui/material";

export const ActionButton = styled.div`
    cursor: pointer;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export abstract class FlowStepEditor<T extends FlowStepData> extends BaseFlowStepEditor {
    private _stepData?: T;

    get stepData(): T {
        if (!this._stepData) throw new AppGlueError("step data not set");
        return this._stepData;
    }

    set stepData(value: T) {
        this._stepData = value;
    }

    get isSelected(): boolean {
        return this.editContext.selection === this._id;
    }

    getFlowStepData(): FlowStepData {
        return this.stepData;
    }

    @AutoBind
    onClick(event: React.MouseEvent<HTMLDivElement>): void {
        if (this.isSelected) {
            event.stopPropagation();
            this.editContext?.setSelection(this.stepData);
        }
    }

    render() {
        return (
            <Box
                width={"100%"}
                display={"flex"}
                flexDirection={"column"}
                position={"relative"}
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                >
                    <StepNameLabel step={this} />
                    {this.renderActionUI()}
                </Box>
                {this.shouldShowDescription && <StepDescription step={this} />}
            </Box>
        );
    }

    renderActionUI = () => {
        if (!this.isSelected) return <></>;

        return (
            <Box
                alignItems={"center"}
                display={"flex"}
                flexDirection={"row"}
                paddingRight={"6px"}
            >
                <ActionButton onClick={this.onClick}>
                    <EditGrayIcon />
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        if (this.isSelected) this.stepData.sequence?.removeStep(this.stepData);
                    }}
                >
                    <DeleteGrayIcon />
                </ActionButton>
                <ActionButton
                    onClick={() => {
                        if (!this.isSelected) return;
                        this.shouldShowDescription = !this.shouldShowDescription;
                        this.stepUpdate();
                    }}
                    data-testid={`${this._id}_toggle-description`}
                >
                    <DescriptionIcon />
                </ActionButton>
            </Box>
        );
    };

    abstract renderEditUI(): JSX.Element | null;

    getStorageData(): object {
        return this.stepData.getStorageData();
    }

    setStorageData(data: object) {
        this.stepData.setStorageData(data);
    }
}
